import { render, staticRenderFns } from "./ariza.vue?vue&type=template&id=1a05cf47&"
import script from "./ariza.vue?vue&type=script&lang=js&"
export * from "./ariza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports